module.exports = __webpack_public_path__ + "media/images/seeds/steveb-cdb45804d766aa22830ff1d5dfdca7d5.jpg";